/**
 * @license
 * Copyright (c) 2018 Crius Authors. All rights reserved.
 */

import '@polymer/polymer/polymer-element.js';

const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `
<dom-module id="cs-shared-styles-base-lists">
	<template>
		<custom-style>
			<style>
                    ol,
                    ul {
                        list-style-type: none;
                        padding-left: var(--cs-theme-ol-and-ul-padding-left-mobile)
                    }

                    ol ol,
                    ol ul,
                    ul ol,
                    ul ul {
                        padding-left: var(--cs-theme-nested-ol-and-ul-padding-left-mobile)
                    }

                    @media only screen and (min-width:1024px) {

                        ol ol,
                        ol ul,
                        ul ol,
                        ul ul {
                            padding-left: var(--cs-theme-nested-ol-and-ul-padding-left-tablet-landscape)
                        }
                    }

                    li {
                        margin: var(--cs-theme-li-margin-mobile);
                        padding-left: 15px
                    }

                    li::before {
                        color: var(--cs-theme-color);
                        margin-left: -15px;
                        margin-right: var(--cs-theme-ul-li-bullet-margin-right-mobile)
                    }

                    @media only screen and (min-width:1024px) {
                        li {
                            margin: var(--cs-theme-li-margin-tablet-landscape);
                            padding-left: 25px
                        }

                        li::before {
                            margin-left: -25px;
                            margin-right: var(--cs-theme-ul-li-bullet-margin-right-tablet-landscape)
                        }
                    }

                    ol {
                        counter-reset: step-counter
                    }

                    ol li {
                        counter-increment: step-counter
                    }

                    ol li::before {
                        content: counter(step-counter) ". ";
                        display: inline-block
                    }

                    ul li::before {
                        content: var(--cs-theme-ul-li-bullet-character)
                    }
        </style>
		</custom-style>
	</template>
</dom-module>`;

document.head.appendChild($_documentContainer.content);